import { StackScreenProps } from "@react-navigation/stack";
import React from "react";

import { useAppNavigation } from "@/hooks/application/navigation";
import { useStoreHallWithProducts, useStoreHalls } from "@/hooks/domain/storeHall";
import { useStoreById } from "@/hooks/domain/stores";
import { HomeNavigation, HomeStackParamList } from "@/navigation/stacks/HomeStack";

import StoreHallListMobile from "./StoreHallList.mobile";

type ScreenProps = StackScreenProps<HomeStackParamList, "storeHallList">;

const StoreHallList = ({ route }: ScreenProps) => {
  const storeId = route.params?.storeId;

  const { navigate, goBack } = useAppNavigation<HomeNavigation>();

  const { data: store, isLoading: isLoadingStore } = useStoreById(storeId);

  const { data: hallList } = useStoreHalls(store?._id, {
    enabled: !!store?._id,
  });

  const {
    data: hallProductList,
    isLoading: isLoadingHallProducts,
    isFetchingNextPage: isLoadingHallProductsNext,
    hasNextPage,
    fetchNextPage,
  } = useStoreHallWithProducts(store?._id, {
    enabled: !!store?._id,
  });

  const onLoadMoreHallProducts = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  const onSelectHall = (hallId: string) => {
    navigate("hallCategoryList", { hallId });
  };

  const onSelectProduct = (productId: string) => {
    navigate("product", { productId });
  };

  return (
    <>
      <StoreHallListMobile
        store={store}
        hallProductsList={hallProductList}
        hallList={hallList}
        isLoading={isLoadingHallProducts || isLoadingStore}
        isLoadingMore={isLoadingHallProductsNext}
        onLoadMore={onLoadMoreHallProducts}
        onSelectHall={onSelectHall}
        onSelectProduct={onSelectProduct}
        onGoBack={() => goBack()}
        onPressSearch={() => navigate("inStoreSearch", { storeId: store?._id })}
      />
    </>
  );
};

export default StoreHallList;
